import { render } from "./developmentalPediaIcon.vue?vue&type=template&id=ef3e8a70"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__